<template>
  <div class="modal micromodal-slide" :class="{'is-open': open}">
    <div @click="close" class="modal__overlay"></div>
    <div class="modal_item error_detail">
      <button @click="close" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
      <!-- <div class="scroll"> -->
      <div class="error_wrap">
        <div v-if="errorMessage != ''">
          <p class="error_text ab" v-html="errorMessage">{{ errorMessage }}</p>
        </div>
        <div v-else>
          <p class="error_text ab">注文に失敗しました</p>
          <p class="error_text ab">再度お試しください</p>
        </div>
      </div>

      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import scrollPosition from '@/model/scrollPosition';

export default {
  props: ['errorMessage'],
  data() {
    return {
      // message: '',
      isOpen: true,
    }
  },
  methods: {
    close () {
      scrollPosition.close();
      // this.isOpen = false;
      this.$emit('modalClose');
    },
    open() {
      scrollPosition.open();
      this.isOpen = true;
    }
  },
  watch: {
    // errorMessage() {
    //   this.message = errorMessage;
    // }
  }
}
</script>

<style lang="css" scoped>
.error_detail {
  border-radius: 12px;
  height: 28%;
  margin: auto;
  overflow: hidden;
  right: 0;
  top: 0;
  width: 91%;
}
.error_wrap {
  text-align: center;
}
.modal_item {
  padding: 80px 15px 0;
}
/* .error_text {
  color: red;
} */
</style>



// WEBPACK FOOTER //
// src/components/common/ErrorModal.vue